import { render, staticRenderFns } from "./EditarAspectos.vue?vue&type=template&id=380cde47&scoped=true"
import script from "./EditarAspectos.vue?vue&type=script&lang=js"
export * from "./EditarAspectos.vue?vue&type=script&lang=js"
import style0 from "./EditarAspectos.vue?vue&type=style&index=0&id=380cde47&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380cde47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('380cde47')) {
      api.createRecord('380cde47', component.options)
    } else {
      api.reload('380cde47', component.options)
    }
    module.hot.accept("./EditarAspectos.vue?vue&type=template&id=380cde47&scoped=true", function () {
      api.rerender('380cde47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/series-documentales/EditarAspectos.vue"
export default component.exports